import { AnswerNoResults } from '../../models/results-types';

export class AnswerConstants {
  static readonly DO_TYPING = [...AnswerNoResults, 'Full'];
  static readonly NO_ANSWER_TEXT = 'Unfortunately, we were unable to find a suitable answer to your question.';
  static readonly NO_ANSWER_TEXT_LOOK_UP = 'Unfortunately, we were unable to find matching resources';
  static readonly ANSWER_HALTED_MESSAGE = 'Answer generation was stopped';
  static readonly REPHRASE_REQUIRED_MESSAGE =
    "It looks like your message might have been mistyped or unclear. Could you please rephrase or clarify what you'd like to discuss or ask about?";
}
